export default __webpack_public_path__ + "static/media/small-logo-x4.93682f4d.svg";